import { colors } from '@/constants/colors';
import IconsLib from '@/utils/IconsLib';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

interface Props {
   label?: string;
   name: string;
   value: string;
   placeholder: string;
   disabled?: boolean;
   error?: boolean;
   onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputCurrency = ({
   label,
   name,
   value,
   placeholder,
   disabled,
   error,
   onChange,
}: Props) => {
   const [inputValue, setInputValue] = useState(value);

   // useEffect(() => {
   //    if (value) {
   //       const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ''));
   //       if (!isNaN(numericValue)) {
   //          setDisplayValue(numericValue.toLocaleString('en-US', {
   //             style: 'currency',
   //             currency: 'USD',
   //             minimumFractionDigits: 2,
   //             maximumFractionDigits: 2
   //          }));
   //       }
   //    } else {
   //       setDisplayValue('');
   //    }
   // }, [value]);

   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value;
      const numericValue = inputValue.replace(/[^0-9.-]+/g, '');

      // Create a synthetic event with the numeric value
      const syntheticEvent = {
         ...e,
         target: {
            ...e.target,
            name,
            value: numericValue,
         },
      } as React.ChangeEvent<HTMLInputElement>;

      setInputValue(numericValue);

      onChange(syntheticEvent);
   };

   return (
      <Wrapper>
         {label && <Label>{label}</Label>}
         <FormWrapper $error={error === true ? 'true' : 'false'}>
            <InputIcon>₱</InputIcon>
            <FormInput
               $disabled={disabled === true ? 'true' : 'false'}
               $error={error === true ? 'true' : 'false'}
               name={name}
               value={inputValue}
               placeholder={placeholder}
               disabled={disabled}
               onChange={handleChange}
            />
         </FormWrapper>

         {error && (
            <ErrorWrapper>
               <IconsLib
                  icon="error-warning-fill"
                  size="15px"
                  color={colors.DANGER}
               />
               <LabelRequired>{label} is required</LabelRequired>
            </ErrorWrapper>
         )}
      </Wrapper>
   );
};

const Wrapper = styled.div`
   display: flex;
   flex-direction: column;
   gap: 0.5rem;
  
`;

const Label = styled.label`
   font-size: 13px;
   /* font-weight: 600; */
   color: ${colors.GRAY1};
`;

const FormInput = styled.input<{
   $disabled: string;
   $error: string;
}>`
   outline: none;
   border: none;

   font-size: 14px;
   color: ${({ $disabled }) =>
      $disabled === 'true' ? colors.GRAY5 : colors.GRAY1};
   background: ${({ $disabled }) =>
      $disabled === 'true' ? colors.GRAY13 : colors.WHITE};
   cursor: ${({ $disabled }) =>
      $disabled === 'true' ? 'not-allowed' : 'text'};

   /* &:focus {
      border-color: ${({ $error }) =>
      $error === 'true' ? colors.DANGER : colors.PRIMARY};
   } */

   &::placeholder {
      color: ${colors.GRAY5};
   }
`;

const LabelRequired = styled.p`
   /* padding-top: 5px; */
   color: ${colors.DANGER};
   font-size: 14px;
`;

const FormWrapper = styled.div<{
   $error: string;
}>`
   display: grid;
   grid-template-columns: 12px 100%;
   border: ${({ $error }) =>
      $error === 'true'
         ? `1px solid ${colors.DANGER}`
         : `1px solid ${colors.GRAY12}`};
   box-shadow: 0 0 0 1px
      ${({ $error }) => ($error === 'true' ? colors.DANGER : colors.PRIMARY)};
   border-radius: 4px;
   padding: 8px 12px;
   transition: border-color 0.2s ease;

   &:focus-within {
      border-color: ${({ $error }) =>
         $error === 'true' ? colors.DANGER : colors.PRIMARY};
      box-shadow: 0 0 0 1px
         ${({ $error }) => ($error === 'true' ? colors.DANGER : colors.PRIMARY)};
   }
`;

const ErrorWrapper = styled.div`
   display: flex;
   justify-content: flex-start;
   align-items: center;
   gap: 5px;
`;

const InputIcon = styled.span`
   font-size: 14px;
   color: ${colors.GRAY1};
`;

export default InputCurrency;
